export enum ManualAssetFields {
    Id = "id",
    AssetType = "assetType",
    HolderName = "holderName",
    AccountIdentifier = "accountIdentifier",
    Urla2020CashOrMarketValueAmount = "urla2020CashOrMarketValueAmount",
    Owner = "owner",
}